import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Eyebrow = ({ children, className = "" }) => (
  <p
    className={`font-mono text-[11px] uppercase tracking-[0.35em] text-volt sm:text-xs ${className}`}
  >
    {children}
  </p>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.85, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const SectionShell = ({ id, children, className = "" }) => (
  <section id={id} className={`relative py-24 sm:py-32 ${className}`}>
    <div className="mx-auto w-full max-w-7xl px-6 sm:px-12 lg:px-20">{children}</div>
  </section>
);
